import * as schema from '@strength/db-schema';
import { z } from 'zod';
import { createAppInsertSchema, schemaToModelChange } from '../../utils/schema';
import { zWorkoutLayer } from '../../workout/layer';
export var BlockDraftWorkoutDomain;
(function (BlockDraftWorkoutDomain) {
    BlockDraftWorkoutDomain.Module = 'BlockDraftWorkout';
    /**
     * Thrown as a BAD_REQUEST by the workout date-move write path (the drag
     * surfaces' shared route) when the workout has logged actuals — an
     * in-progress workout's logged history belongs to its original date. The
     * drag surfaces warn before the save; the web maps a server rejection
     * with this message to the same warning, for when the client's actuals
     * view lags the server.
     */
    BlockDraftWorkoutDomain.WORKOUT_HAS_LOGGED_ACTUALS_ERROR = 'WORKOUT_HAS_LOGGED_ACTUALS_ERROR';
    /**
     * Thrown as a BAD_REQUEST by the draft save's verify step (SC-5512) when a
     * create would land a live day document on a slot
     * (org, block, cycle_sort_order, session_sort_order) already occupied by
     * another live row. The web maps a rejection carrying this message to a
     * conflict toast; there is deliberately no unique DB index (sibling bumps
     * run as separate transactions, and an empty slot is legal).
     */
    BlockDraftWorkoutDomain.SLOT_OCCUPIED_ERROR = 'BLOCK_DRAFT_SLOT_OCCUPIED_ERROR';
    BlockDraftWorkoutDomain.zEdit = schemaToModelChange('BlockDraftWorkoutLayer', createAppInsertSchema(schema.BlockDraftWorkoutLayer)
        .omit({
        unpublishedChangeCount: true,
        blockId: true,
        workoutId: true,
    })
        .extend({
        // `createInsertSchema` doesn't handle the layer type very well
        layer: zWorkoutLayer,
    }));
    const zIdentity = z.object({
        blockId: z.uuid(),
        workoutId: z.uuid(),
    });
    BlockDraftWorkoutDomain.zCommand = z.object({
        module: z.literal(BlockDraftWorkoutDomain.Module),
        identity: zIdentity,
        edits: BlockDraftWorkoutDomain.zEdit.array(),
    });
})(BlockDraftWorkoutDomain || (BlockDraftWorkoutDomain = {}));
//# sourceMappingURL=domain.js.map